/*
 * @Description: sm相关静态变量
 * @Author: zhu xue song
 * @Date: 2021-11-02 10:42:18
 * @LastEditors: zhu xue song
 * @LastEditTime: 2021-11-02 10:44:54
 * @FilePath: \rongxin.loan.user.app.api\utils\smUtil\constant.js
 */
export default {
  Mode: {
    SM2: {
      C1C2C3: 0,
      C1C3C2: 1
    },
    SM4: {
      CBC: 'cbc',
      ECB: 'ecb'
    }
  }
};
